import ACTIVITIES from './activities.graphql'
export {ACTIVITIES}



// WEBPACK FOOTER //
// ./src/modules/common/graphql/activities/index.ts